import { makeApiCall } from "@swiggy-private/js-utils";
import { API_ENDPOINTS, DINEOUT_CART_API_HOST } from "../constants/api";
import { customApiCall, IOptions } from "../utils/api";

export interface IQuickActionsRequest {
    tableId: string;
    restaurantId: string;
    actionId: string;
    actionName: string;
    parentOrderId?: string;
}

export interface IQuickActionsResponse {
    success: {
        status: string;
        message: string;
    };
}

export const triggerQuickAction = async (params: IQuickActionsRequest, _makeApiCall: typeof makeApiCall) => {
    const options: IOptions = {
        bodyParams: { ...params },
        method: "POST",
    };

    const response = await customApiCall<IQuickActionsResponse>({
        _makeApiCall,
        apiHost: DINEOUT_CART_API_HOST,
        apiEndpoint: API_ENDPOINTS.QUICK_ACTIONS,
        opts: options,
    });

    return response;
};
